var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5452 12.7636C18.557 11.8438 18.8014 10.9418 19.2555 10.1418C19.7095 9.34172 20.3586 8.66952 21.1423 8.18772C20.6445 7.4767 19.9877 6.89156 19.2241 6.47877C18.4606 6.06598 17.6113 5.83692 16.7437 5.80978C14.8931 5.61552 13.0989 6.91719 12.1558 6.91719C11.1945 6.91719 9.74254 5.82907 8.17897 5.86123C7.16762 5.89391 6.18198 6.188 5.31808 6.71486C4.45418 7.24172 3.74149 7.98338 3.24945 8.86757C1.11807 12.5578 2.70789 17.9812 4.7496 20.9641C5.77113 22.4248 6.96498 24.0564 8.52714 23.9985C10.0558 23.9351 10.6267 23.0237 12.4719 23.0237C14.3 23.0237 14.8357 23.9985 16.4295 23.9617C18.0698 23.9351 19.1033 22.4946 20.089 21.0201C20.823 19.9793 21.3877 18.8291 21.7624 17.6119C20.8094 17.2088 19.9962 16.5342 19.4241 15.672C18.852 14.8098 18.5463 13.7983 18.5452 12.7636Z",
    fill: "#190D1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5348 3.84696C16.4292 2.7733 16.8698 1.39329 16.7632 0C15.3968 0.143513 14.1346 0.796561 13.2281 1.82903C12.7849 2.33341 12.4455 2.9202 12.2292 3.55585C12.0129 4.1915 11.9241 4.86354 11.9677 5.53356C12.6511 5.5406 13.3272 5.39246 13.9451 5.10031C14.563 4.80817 15.1066 4.37962 15.5348 3.84696V3.84696Z",
    fill: "#190D1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.434ac60576ce941d3ff8a842b70e4a25.svg";
export { ForwardRef as ReactComponent };